<script lang="ts">
  import { Check } from "lucide-svelte"

  interface Props {
    book: BookType
    onview: (book: BookType) => void
  }

  let props = $props()
  let { book, onview }: Props = props

  let completed = $state(false)
  if (
    book?.plan_book?.status === "completed" ||
    book?.plan_book?.status === "marked_as_read"
  ) {
    completed = true
  }
</script>

<button
  type="button"
  onclick={() => onview(book)}
  class="swiper-slide shadow-lg h-40 relative"
  aria-label={`View book: ${book?.title ?? ""}`}
>
  {#if completed}
    <div
      class="h-12 w-12 bg-green-400 rounded-full absolute top-2 right-2 flex items-center justify-center"
    >
      <Check class="w-8 h-8 text-core" />
    </div>
  {/if}
  <div class="aspect-w-3 aspect-h-8">
    <img src={book.image_url} class="object-cover" alt={book.title} />
  </div>
</button>

<style>
  .swiper-slide {
    height: 20rem;
    -webkit-transition: 250ms all;
    transition: 250ms all;
  }

  .swiper-slide:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    z-index: 1;
  }

  .swiper-slide:first-child:hover {
    margin: 0 40px;
  }

  .swiper-slide:last-child:hover {
    margin: 0 -40px;
  }
</style>
